// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { useEffect, useState } from "react";

export const useIsExists = (id: string, containerId: string) => {
    const [isExists, setIsExists] = useState(false);

    useEffect(() => {
        const checkIfElementExists = () => {
            const element = document.getElementById(id);
            setIsExists(!!element);
            return !!element;
        };

        checkIfElementExists();

        const container = document.getElementById(containerId);
        if (!container) {
            return;
        }

        const observer = new MutationObserver(() => {
            if (checkIfElementExists()) {
                observer.disconnect();
            }
        });

        observer.observe(container, { childList: true, subtree: true });

        return () => {
            observer.disconnect();
        };
    }, []);

    return isExists;
};
